const UserEmptySvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 310 310"
    >
      <g fill="none">
        <path fill="#EBEDEE" d="M0 0h310v310H0z" />
        <path
          fill="#BBB"
          d="M258.74667 310H51.25333v-35.54667c0-30.18525 30.61767-55.38666 62-55.38666h83.49334c31.38233 0 62 25.2014 62 55.38666V310zM96.72 134.74667c0-31.95205 25.91462-57.86667 57.86667-57.86667 31.95204 0 57.86666 25.91462 57.86666 57.86667 0 31.95204-25.91462 57.86666-57.86666 57.86666-31.95205 0-57.86667-25.91462-57.86667-57.86666z"
        />
      </g>
    </svg>
  );
};

export default UserEmptySvg;
